import { render, staticRenderFns } from "./ProfileDeleted.vue?vue&type=template&id=09a3bfde&scoped=true"
import script from "./ProfileDeleted.vue?vue&type=script&lang=js"
export * from "./ProfileDeleted.vue?vue&type=script&lang=js"
import style0 from "./ProfileDeleted.vue?vue&type=style&index=0&id=09a3bfde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a3bfde",
  null
  
)

export default component.exports